import { render, staticRenderFns } from "./MiniPolicyCard.vue?vue&type=template&id=70238e69&lang=pug&"
import script from "./MiniPolicyCard.vue?vue&type=script&lang=js&"
export * from "./MiniPolicyCard.vue?vue&type=script&lang=js&"
import style0 from "./MiniPolicyCard.vue?vue&type=style&index=0&id=70238e69&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports